/**
 * @generated SignedSource<<cfc3e413fd611d3709ff66a12e536aa6>>
 * @relayHash 74b5a433540c2db27180ab37acc51131
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fef66b1932b90e02a16bcc721ad869a60dd63043e0d61d1c74c265d74f27ec9c

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CustomerDetailsCustomerDetailsPageQuery } from './CustomerDetailsCustomerDetailsPageQuery.graphql';

import isAssetsFieldEnabled_provider from '@jira/platform__graphql-relay-provider/src/csmNativeAssetsFieldCustomerContextRelayprovider';

const node: PreloadableConcreteRequest<CustomerDetailsCustomerDetailsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "fef66b1932b90e02a16bcc721ad869a60dd63043e0d61d1c74c265d74f27ec9c",
    "metadata": {},
    "name": "CustomerDetailsCustomerDetailsPageQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrccsmNativeAssetsFieldCustomerContextRelayprovidertsx": isAssetsFieldEnabled_provider
    }
  }
};

export default node;
